import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useStyles from './style'
import { Box, Button, Dialog, Divider, Drawer, Grid, IconButton, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import helper from '@utils/helper'
import closeIcon from '../../../assets/icons/payment/close.svg'
import TranferIcon from '../../../assets/icons/payment/logo-transfer.svg'
import MomoIcon from '../../../assets/icons/payment/logo-momo1.svg'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export const STATUS = {
    SUCCESS: 'success',
    FAILURE: 'failure',
    PENDING: 'pending'
}

const PAYMENT_TYPES = {
  CURRENT_BALANCE: 'wallet',
  BANK_TRANSFER: 'bank-transfer',
  CREDIT_CARD: 'credit-card',
  MOMO: 'momo',
  MOCHA: 'mocha',
  VNPAY: 'vnpay',
  PAYPAL: 'paypal',
}

const PAYMENT_ICON = {
  CURRENT_BALANCE: TranferIcon,
  BANK_TRANSFER: TranferIcon,
  CREDIT_CARD: TranferIcon,
  MOMO: MomoIcon,
  MOCHA: TranferIcon,
  VNPAY: TranferIcon,
  PAYPAL: TranferIcon,
}

const InvoiceDraw = ({ 
  open, 
  onClose, 
  handleClickBtn, 
  status, 
  amount, 
  id, 
  time, 
  invoiceDetails, 
  cancelledBy, 
  approvedAt,
  cancelledAt,
  approvedByDetail, 
  paymentTypeDetail, 
  customerDetail, 
  cancelStatus,
  ...otherProps }) => {
    console.log(status)
    const classes = useStyles()

    const formatDate = (date) =>{
        const d = new Date(date);
        return `${d.toLocaleTimeString("vi", {
            hour: "2-digit",
            minute: "2-digit",
          })} - ${d.toLocaleDateString("vi", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
          })}`
    }
    const formatTransferICon = (type)=>{
      switch (type) {
        case PAYMENT_TYPES.BANK_TRANSFER:
          return PAYMENT_ICON.BANK_TRANSFER;
        case PAYMENT_TYPES.CURRENT_BALANCE:
          return PAYMENT_ICON.CURRENT_BALANCE;
        case PAYMENT_TYPES.CREDIT_CARD:
          return PAYMENT_ICON.CREDIT_CARD;
        case PAYMENT_TYPES.MOCHA:
          return PAYMENT_ICON.MOCHA;
        case PAYMENT_TYPES.MOMO:
          return PAYMENT_ICON.MOMO;
        case PAYMENT_TYPES.VNPAY:
          return PAYMENT_ICON.VNPAY;
        case PAYMENT_TYPES.PAYPAL:
          return PAYMENT_ICON.PAYPAL;
        default:
          break;
      }
    }
    const [anchorElCancel, setAnchorElCancel] = useState(null);
    const openCancel = Boolean(anchorElCancel);
    const [dialogCancel,setDialogCancel] = useState(false)
    const handlePopoverOpenCancel = (event) => {
      setAnchorElCancel(event.currentTarget);
    };
    const handlePopoverCloseCancel = () => {
      setAnchorElCancel(null);
    };

    const handleClose = ()=>{
      setDialogCancel(false)
      handlePopoverCloseCancel()
    }

    const [reason,setReason] = useState("")
    const handleChangeReason = (e) => {
      setReason(e?.target?.value || "")
    };

    const handleCancel = async()=>{
      if(reason && reason!==""){
        fetch(`/api/billing/transactions/${id}/cancel`, {
              body: JSON.stringify({reason}),
              secure: true,
              method: 'PATCH',
              headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('sid')}` },
          }).then(res => {
              return res;
          })
          .then(data => {
              // window.open('/transactions', '_self')
              window.location.reload()
              handleClose()
          })
        setDialogCancel(false)
        handlePopoverCloseCancel()
      }
    }
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        classes={{ paper: classes.drawPaper }}
      >
        <Box role="presentation">
          <Typography className={classes.drawTitle}>
            Chi tiết giao dịch
            <IconButton className={classes.drawIconClose} onClick={onClose}>
              <img src={closeIcon} alt="closeIcon" />
            </IconButton>
          </Typography>
          <Typography className={classes.drawAmout}>
            {helper.formatCash.format(amount || 0)}
          </Typography>
          <Typography className={classes.drawId}>{id}</Typography>
          <Divider />
          <Typography className={classes.drawLabel}>Thời gian</Typography>
          <Typography className={classes.drawTime}>
          {formatDate(time)}
          </Typography>
          <TableContainer
            component={Paper}
            classes={{
              root: classes.drawTablePaper,
            }}
          >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    classes={{
                      root: classes.drawTableCell,
                    }}
                    align="left"
                  >
                    Sản phẩm
                  </TableCell>
                  <TableCell
                    classes={{
                      root: classes.drawTableCell,
                    }}
                    align="center"
                  >
                    Số lượng
                  </TableCell>
                  <TableCell
                    classes={{
                      root: classes.drawTableCell,
                    }}
                    align="right"
                  >
                    Giá
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceDetails?.map((invoice, index) => (
                  <TableRow key={index}>
                    <TableCell
                      classes={{
                        root: classes.drawTableCell,
                      }}
                      align="left"
                      component="th"
                      scope="row"
                    >
                      {invoice?.items[0]?.description}
                    </TableCell>
                    <TableCell
                      classes={{
                        root: classes.drawTableCell,
                      }}
                      align="center"
                    >
                      1
                    </TableCell>
                    <TableCell
                      classes={{
                        root: classes.drawTableCell,
                      }}
                      align="right"
                    >
                      {helper.formatCash.format(invoice?.items[0]?.amount || 0)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    classes={{
                      root: classes.drawTableCell,
                    }}
                    style={{ border: "none" }}
                    align="center"
                  ></TableCell>
                  <TableCell
                    classes={{
                      root: classes.drawTableCell,
                    }}
                    style={{ border: "none", color: "#131313" }}
                    align="center"
                  >
                    Tổng
                  </TableCell>
                  <TableCell
                    classes={{
                      root: classes.drawTableCell,
                    }}
                    style={{ border: "none", color: "#131313" }}
                    align="right"
                  >
                    {helper.formatCash.format(amount || 0)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            className={classes.drawTransferContainer}
          >
            <Grid item>
              <Typography className={classes.drawLabel} style={{ margin: 0 }}>
                Phương thức thanh toán
              </Typography>
              <Typography className={classes.drawTransfer}>
                {paymentTypeDetail?.title || "Chuyển khoản"}
              </Typography>
            </Grid>
            <Grid item>
              <img
                src={formatTransferICon(paymentTypeDetail?.code) || TranferIcon}
                alt="TranferIcon"
              />
            </Grid>
            
          </Grid>
          {
              status === STATUS.SUCCESS && <Grid style={{ margin: "-20px 0 !important" }}>
                <IconButton onClick={handlePopoverOpenCancel}>
                  <MoreHorizIcon />
                </IconButton>
              </Grid>
            }
          <Grid container className={classes.infoContainer}>
            <Grid item xs={12}>
              <Typography className={classes.drawLabel}>Trạng thái</Typography>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                {status === STATUS.PENDING ? (
                  <>
                    <Grid item xs={6} gap={10}>
                      <Button
                        variant="contained"
                        className={clsx("force-square", classes.statusBtn)}
                        onClick={() =>
                          handleClickBtn(customerDetail, amount, id, false)
                        }
                        style={{background: "#E0E0E0", color:"black"}}
                      >
                        Từ chối
                      </Button>
                    </Grid>
                    <Grid
                      item
                      container
                      xs={6}
                      justifyContent="flex-end"
                    >
                      <Button
                        variant="contained"
                        style={{ maxWidth: "220px",background:"#40B60A"}}
                        className={clsx("force-square", classes.statusBtn)}
                        onClick={() =>
                          handleClickBtn(customerDetail, amount, id, true)
                        }
                      >
                        Xác nhận
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <Button
                    className={clsx(
                      status === STATUS.FAILURE
                        ? classes.statusBtnReject
                        : classes.statusBtnAccept,
                      classes.statusBtn
                    )}
                    style={{color: status === STATUS.FAILURE ? "#C62026" : "#40B60A", border: status === STATUS.FAILURE ? "1px solid #C62026" : "1px solid #40B60A"}}
                    variant="outlined"
                  >
                    {status === STATUS.FAILURE ? "Đã từ chối" : "Đã xác nhận"}
                  </Button>
                )}
              </Grid>
              {status === STATUS.FAILURE ? (
              <>
              <Typography
                className={classes.drawInfo}
              >{`${cancelledBy?.firstName} ${cancelledBy?.lastName}`}</Typography>
              <Typography className={classes.drawInfo}>
                {cancelledAt ? formatDate(cancelledAt) : ""}
              </Typography>
              </>
              )
              :
              status === STATUS.SUCCESS? (
                <>
              <Typography
                className={classes.drawInfo}
              >{`${approvedByDetail?.firstName} ${approvedByDetail?.lastName}`}</Typography>
              <Typography className={classes.drawInfo}>
                {approvedAt ? formatDate(approvedAt) : ""}
              </Typography>
              </>
              )
              : ""
}
            </Grid>
          </Grid>
        </Box>
        <Popover
          id="cancel-transaction"
          className={classes.popover}
          classes={{
          paper: classes.paper,
          }}
          open={openCancel}
          anchorEl={anchorElCancel}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          onClose={handlePopoverCloseCancel}
        >
          <Button
            className={clsx(
              classes.statusBtnReject,
              classes.Btn
            )}
            color="primary"
            variant="outlined"
            onClick={()=>setDialogCancel(true)}
          >
            Hủy giao dịch
          </Button>
        </Popover>
        <Dialog open={dialogCancel} onClose={handleClose} className={classes.dialogContent}>
          <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' ,padding: '34px 43px', width: '423px' }}>
              <Box sx={{ fontSize: '20px', fontWeight: '500', color: '#000000'}}>
                Lý do huỷ giao dịch
              </Box>
              <Box sx={{ color:'#41B60B', padding: '24px 0px', width:"100%" }}>
                  <TextField 
                   label="Nhập lý do"
                   multiline
                   onChange={handleChangeReason}
                   fullWidth
                   error= {reason!=="" ? false : true}
                   helperText={reason!=="" ? "" : "Vui lòng nhập lý do"}
                  />
              </Box>
              <Box sx={{ display: 'flex', marginTop: '24px', justifyContent: 'space-between', width: '100%',
                  '& .MuiButton-root': {
                      padding: '5px 30px',
                      width: '48%'
                  }
              }}>
                  <Button onClick={handleClose} variant='contained' className={clsx(classes.Btn)}> Huỷ</Button>
                  <Button
                      className={clsx("force-square", classes.Btn)}
                      variant="contained"
                      color="primary"
                      onClick={handleCancel}
                  > Xong
                  </Button>
              </Box>
          </Box>
        </Dialog>
      </Drawer>
    );
}

InvoiceDraw.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    amount: PropTypes.number, id: PropTypes.string, 
    time: PropTypes.string, 
    invoiceDetails: PropTypes.any, 
    customerDetail: PropTypes.any, 
}

InvoiceDraw.defaultProps = {
    open: false,
    children: null,
}

export default InvoiceDraw